export default __webpack_public_path__ + "static/media/dca-ico.bc19208f.png";